import { FlattenedSurveyAnswers } from "utils/v3/surveyUtils";

export const LEARNING_RESOURCE_INTERESTS_QUESTION = "learning-resource-interests";

type TopicWithId = {
  topicId?: string;
};

export const topicIdToInterestValue = (topicId: string): string =>
  topicId.replace(/([a-z0-9])([A-Z])/g, "$1_$2").toLowerCase();

export const getSelectedLearningResourceInterestValues = (
  flattenedSurveyAnswers: FlattenedSurveyAnswers | Record<string, unknown>
): string[] => {
  const raw = flattenedSurveyAnswers[LEARNING_RESOURCE_INTERESTS_QUESTION];

  if (Array.isArray(raw)) {
    return raw.map(String);
  }

  if (typeof raw === "string" && raw.length > 0) {
    return [raw];
  }

  return [];
};

export const sortPersonalizedResourceTopicsByInterests = <T extends TopicWithId>(
  topics: T[],
  selectedValues: string[]
): T[] => {
  if (!topics.length || !selectedValues.length) {
    return topics;
  }

  const selectedSet = new Set(selectedValues);
  const selected: T[] = [];
  const rest: T[] = [];

  topics.forEach((topic) => {
    const interestValue = topic.topicId
      ? topicIdToInterestValue(topic.topicId)
      : "";

    if (interestValue && selectedSet.has(interestValue)) {
      selected.push(topic);
    } else {
      rest.push(topic);
    }
  });

  selected.sort((left, right) => {
    const leftValue = left.topicId ? topicIdToInterestValue(left.topicId) : "";
    const rightValue = right.topicId ? topicIdToInterestValue(right.topicId) : "";
    return selectedValues.indexOf(leftValue) - selectedValues.indexOf(rightValue);
  });

  return [...selected, ...rest];
};
